import React from "react";
import "./tabs.scss";

interface PerformanceGaugeProps {
  score: number;
}

const PerformanceGauge: React.FC<PerformanceGaugeProps> = ({ score }) => {
  const position = Math.max(0, Math.min(100, score));

  // Calculate position on the curve
  const x = 20 + (position / 100) * 360;
  const t = (position / 100) * Math.PI;
  const y = 180 - Math.sin(t) * 160;

  return (
    <div className="performance-gauge">
      <svg
        className="gauge-svg"
        viewBox="0 0 400 200"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="gauge-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#10b981" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#10b981" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <path
          d="M 20 180 Q 100 20 200 20 Q 300 20 380 180"
          fill="none"
          stroke="#10b981"
          strokeWidth="3"
        />
        <path
          d="M 20 180 Q 100 20 200 20 Q 300 20 380 180 L 380 180 L 20 180 Z"
          fill="url(#gauge-gradient)"
          opacity="0.3"
        />
        <circle
          cx={x}
          cy={y}
          r="8"
          fill="#10b981"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
      <div className="gauge-labels">
        <div className="gauge-label">
          <div className="label-line red" />
          <span>Needs Work</span>
        </div>
        <div className="gauge-label">
          <div className="label-line green" />
          <span>On Track</span>
        </div>
        <div className="gauge-label">
          <div className="label-line gray" />
          <span>Good Job</span>
        </div>
      </div>
    </div>
  );
};

export default PerformanceGauge;

